import React, { memo, useState, useEffect } from "react";
import "./AddMarket.css";
import { Container, Col, Row, Label, Button } from "reactstrap";
import TextField from "@mui/material/TextField";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { checkImpersonation } from "../../../helpers/dataHelper";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Config } from "../../../Utils/Config";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import Tooltip from "@mui/material/Tooltip";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { useDispatch } from "react-redux";

var intervalID;
let summary = [];

let availCount = null;

const AddMarket = memo((props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { state } = location;
  const [activeStep, setActiveStep] = useState(props.isEdit ? 1 : 0);
  const [marketInfo, setMarketInfo] = useState({
    marketName: props.marketName !== undefined ? props.marketName : "",
  });
  const [marketResult, setMarketResult] = useState({});
  const profileData = props.profileData.profileInfo;
  const [errMsg, setErrMsg] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [marketId, setMarketId] = useState(null);
  const [availableCount, setAvailableCount] = useState(null);
  // const [timeLeft, setTimeLeft] = useState(null);
  let From = state && state !== null ? state.isFrom : null;
  let myStoreOpen = (JSON.parse(localStorage.getItem('user')).usertype === 'Free' || JSON.parse(localStorage.getItem('user')).usertype === 'Basic') && From !== 'my-market' && From == null && !availCount ? true : false;
  localStorage.setItem('opened', myStoreOpen);

  useEffect(() => { }, [availableCount])
  //move the stepper to next level
  const nextStep = (value) => {
    if (
      value !== 2 ||
      (value === 2 &&
        marketInfo.marketName !== undefined &&
        marketInfo.marketName !== "" &&
        errMsg === "")
    ) {
      if (value === 2 || value === 3) {
        stopInterval();
      }
      if (value === 1 || value === 4) {
        checkAvailableCount();
      }
      setActiveStep(value);
      props.setActiveStep(value);
      setErrMsg("");
    } else if (
      marketInfo.marketName === undefined ||
      marketInfo.marketName === ""
    ) {
      setErrMsg("Market name is required");
    }
  };

  const navigateToBuyMarket = () => {
    if (
      marketInfo.marketName !== undefined &&
      marketInfo.marketName !== "" &&
      errMsg === "" && !localStorage.getItem('impersonated')
    ) {
      async function getMarketCredit() {

        const { profile } = profileData || {};
        const updatedAddress = [
          profile?.streetaddress1 || props?.address,
          profile?.streetaddress2,
          profile?.city,
          profile?.statecode,
          profile?.zipcode
        ]
          .filter(Boolean)
          .join(", ");

        const profileId = profile?.profileid ?? null;
        const payload = {
          "marketname": marketInfo?.marketName,
          "latitude": props.latitude,
          "longitude": props.longitude,
          "supplyradius": props.supplyRadius,
          "demandradius": props.demandRadius,
          "profileid": profileId,
          "populationcenterid": null,
          "address": updatedAddress,
          "rvparkscount": props?.rvcount || null
        }
        let refId = null;
        try {
          const referenceResult = await apiCommonTrigger("post", `${Config.API_URL}/markets/reference`, payload);
          refId = referenceResult?.data;
        } catch (error) {
          handlingCatchError(error);
          setLoading(false);
        }

        await apiCommonTrigger("post", `${Config.API_URL}/subscription/buymarketcredit`, {
          "lookupkey": Config.LookupKey,
          "referenceurl": `${window.location.origin}/add-market-payment-success/${refId}`,
          "referenceid": refId
        }).then((res) => {
          if (res.status === 200) {
            window.open(res.headers.location, "_self")
          }
          else {
            setLoading(false);
            handlingCatchError(res, navigate);
          }
        })
          .catch(err => {
            handlingCatchError(err, navigate);
          })

      }
      getMarketCredit();
      startInterval();
      // window.open("/buy-report");
      // window.open("/account-subscription?type=single-prepaid-report");
    }
    else {
      if (localStorage.getItem('impersonated') === 'true') {
        checkImpersonation();
      } else {
        setErrMsg("Market name is required");
      }
    }

  }

  //clear stepper and msg
  const clearAll = (value) => {
    navigate("/market-search", { state: {} });
    setActiveStep(0);
    setErrMsg("");
    props.showAddMarket(false, "1", value);
    window.location.reload();
  };

  //common dialog close
  const handleBack = () => { };

  //common onchange event
  const handleChange = (e) => {
    setErrMsg("");
    if (e.target.value !== "") {
      var numericRegex = /^[0-9A-Za-zÀ-ÿ\s,._+;()*~'#@!?&-]+$/;// /^[a-zA-Z0-9\s\. ]*$/;
      const valid = numericRegex.exec(e.target.value);
      if (valid) {
        if (e.target.value.length > 2 && e.target.value.length < 101) {
          setMarketInfo({ ...marketInfo, [e.target.name]: e.target.value });
        } else {
          setErrMsg("Market name should be 3 to 100 characters");
        }
      } else {
        setErrMsg("Market name is invalid");
      }
    } else {
      setMarketInfo({});
      setErrMsg("Market name is required");
    }
  };

  //common call to create market
  const submitRequest = (isFrom) => {
    if (
      marketInfo.marketName !== undefined &&
      marketInfo.marketName !== "" &&
      errMsg === ""
    ) {
      createMarket(isFrom);
      setErrMsg("");
      stopInterval();
      localStorage.setItem('opened', false);
    } else {
      setErrMsg("Market name is required");
    }

  };

  //get market summary details
  const getMarketSummary = () => {
    setLoading(true);
    apiCommonTrigger("post", `${Config.API_URL}/markets/market/summary`, {
      latitude: props.latitude ? props.latitude : 0,
      longitude: props.longitude ? props.longitude : 0,
      supplyRadius: props.centerRadius ? props.centerRadius : 100,
      demandRadius: props.centerRadius ? props.centerRadius : 100,
    }).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setMarketResult({ ...marketResult, marketResult: res.data });
      } else {
        handlingCatchError(res, navigate);
      }
      nextStep(4);
    })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };



  //add market
  const createMarket = (isFrom) => {
    let address =
      profileData &&
        profileData !== undefined &&
        profileData.profile.streetaddress1
        ? profileData.profile.streetaddress1 + ", "
        : props.address
          ? props.address
          : "";
    let address2 =
      profileData &&
        profileData !== undefined &&
        profileData.profile.streetaddress2
        ? profileData.profile.streetaddress2 + ", "
        : "";
    let city =
      profileData && profileData !== undefined && profileData.profile.city
        ? profileData.profile.city + ", "
        : "";
    let state =
      profileData && profileData !== undefined && profileData.profile.statecode
        ? profileData.profile.statecode + " "
        : "";
    let zipCode =
      profileData && profileData !== undefined && profileData.profile.zipcode
        ? profileData.profile.zipcode
        : "";
    let profileId =
      profileData && profileData !== undefined && profileData.profile.profileid
        ? profileData.profile.profileid
        : null;
    setLoading(true);
    apiCommonTrigger("post", `${Config.API_URL}/markets/market`, {
      latitude: props.latitude ? props.latitude : 0,
      longitude: props.longitude ? props.longitude : 0,
      supplyRadius: props.centerRadius ? props.centerRadius : 100,
      demandRadius: props.centerRadius ? props.centerRadius : 100,
      marketName: marketInfo.marketName ? marketInfo.marketName : "",
      id: props.isEdit ? props.marketId : 0,
      profileId: profileId,
      populationCenterId: null,
      address: address + address2 + city + state + zipCode,
      RvparksCount:
        isFrom === "1"
          ? props.summaryData && props.summaryData.rvcount !== undefined
            ? props.summaryData.rvcount
            : null
          : isFrom === "2"
            ? marketResult.marketResult &&
              marketResult.marketResult.rvparksinmarket !== undefined
              ? marketResult.marketResult.rvparksinmarket
              : null
            : null,
    }).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        if (isFrom === 1) {
          clearAll("1");
        } else {

          setActiveStep(5);
          // checks the userAvailability to show btn accordingly
          checkAvailableCount();
          // startInterval();
          //   setRunCheckCount(true);
          //   // setTimeout(function () {
          //     checkAvailableCount();
          // //  },3000) ;
          setMarketId(res.data.marketId);
          localStorage.setItem('marketId', res.data.marketId)
        }
      } else {
        handlingCatchError(res, navigate);
      }
    })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
  };

  //price conversion
  const priceConversion = (tot) => {
    if (tot === null || tot === undefined)
      return '-';

    if (tot !== "") {
      let checkDigit = tot.toString().split(".");
      let ret = "";
      let i = 0;
      if (tot.toString().indexOf(".") == -1) {
        tot = tot;
      } else {
        if (checkDigit == "00") {
          tot = checkDigit.trim();
        } else {
          if (checkDigit.length === 2) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              if (i >= checkDigit[1].length) ret += "0";
              else ret += checkDigit[1][i];
            }
          } else if (checkDigit.length === 1) {
            ret += checkDigit[0] + ".";
            for (i = 0; i < checkDigit.length; i++) {
              ret += "0";
            }
          }
          ret = ret.toString();
          tot = ret;
        }
      }
    }
    return tot.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  //summary info display
  const getSummaryDetails = () => {
    summary = [];
    let summaryDetails = marketResult.marketResult;
    for (let i = 0; i < Object.keys(summaryDetails).length; i++) {
      if (
        Object.values(summaryDetails)[i] !== null &&
        Object.values(summaryDetails)[i] !== undefined &&
        Object.values(summaryDetails)[i] !== "" &&
        Object.values(summaryDetails)[i] !== 0 &&
        Object.keys(summaryDetails)[i] !== "rvparkids" &&
        Object.values(summaryDetails)[i] !== "N/A" &&
        // Object.keys(summaryDetails)[i] !== "population" &&
        Object.keys(summaryDetails)[i] !== "caucasian" &&
        Object.keys(summaryDetails)[i] !== "black" &&
        Object.keys(summaryDetails)[i] !== "hispanic" &&
        Object.keys(summaryDetails)[i] !== "others" &&
        Object.keys(summaryDetails)[i] !== "avgmaleinmarket" &&
        Object.keys(summaryDetails)[i] !== "avgfemaleinmarket" &&
        Object.keys(summaryDetails)[i] !== "asianpacific" &&
        Object.keys(summaryDetails)[i] !== "marketdemandformarket" &&
        Object.keys(summaryDetails)[i] !== "marketdemandfornational" &&
        Object.keys(summaryDetails)[i] !== "demandsupplyratioformarket" &&
        Object.keys(summaryDetails)[i] !== "demandsupplyratiofornational" &&
        Object.keys(summaryDetails)[i] !== "rvparkdemandscoreFormarket" &&
        // Object.keys(summaryDetails)[i] !== "potentialcampers" &&
        Object.keys(summaryDetails)[i] !== "percentageofhousehold" && 
        Object.keys(summaryDetails)[i] !== "rvparkdemandscoreFornational" &&
        Object.keys(summaryDetails)[i] !== "rvparkdemandscoreformarket"         
      ) {
        let tableHeader =
          Object.keys(summaryDetails)[i] === "rvparksinmarket"
            ? "RV Parks in market"
            : Object.keys(summaryDetails)[i] === "avgpricepernight"
              ? "Average price per night"
              : Object.keys(summaryDetails)[i] === "totalrvparksites"
                ? "Total Camping spots"
                : Object.keys(summaryDetails)[i] === "countofhousehold"
                  ? "Households"
                  : Object.keys(summaryDetails)[i] === "marketscore"
                    ? "Market Score"
                    : Object.keys(summaryDetails)[i] === "demandscore"
                      ? "Demand Score"
                      : Object.keys(summaryDetails)[i] === "potentialcampers"
                        ? "Potential Campers"
                        : Object.keys(summaryDetails)[i] === "avgsizeofpark"
                          ? "Average Size Of Park"
                          : Object.keys(summaryDetails)[i] === "rvownershipinmarket"
                            ? "RV Ownership in market"
                            : Object.keys(summaryDetails)[i] === "percentageofhousehold"
                              ? "% Of Households that camp"
                              : Object.keys(summaryDetails)[i] === "population"
                                ? "Population"
                                : Object.keys(summaryDetails)[i] === "incomepercapita"
                                  ? "Income per capita"
                                  : Object.keys(summaryDetails)[i] === "avgfuelcost"
                                    ? "Averge Fuel Cost"
                                    : Object.keys(summaryDetails)[i] === "avgage"
                                      ? "Average Age"
                                      : Object.keys(summaryDetails)[i] === "fivetotwentyfour"
                                        ? "Population age from 5-24"
                                        : Object.keys(summaryDetails)[i] === "twentyfivetofortyfour"
                                          ? "Population age from 25-44"
                                          : Object.keys(summaryDetails)[i] === "fortyfivetofiftyfour"
                                            ? "Population age from 45-54"
                                            : Object.keys(summaryDetails)[i] === "fiftyfivetoseventyfour"
                                              ? "Population age from 55-74"
                                              : Object.keys(summaryDetails)[i] === "seventyfiveandabove"
                                                ? "Population age of 75 And Above"
                                                : Object.keys(summaryDetails)[i] === "populationdensity" 
                                                  ? "Population density (per sq mi)"
                                                  : Object.keys(summaryDetails)[i] === "regiontype"
                                                    ? "Region type"
                                                    : Object.keys(summaryDetails)[i] === "rvparkdemandscoreformarket"
                                                    ? "RV Park Demand Score For Market"
                                                : Object.keys(summaryDetails)[i];
        let formatValue = priceConversion(Object.values(summaryDetails)[i]);
        let headerValue =
          (Object.keys(summaryDetails)[i] === "avgfuelcost" ||
            Object.keys(summaryDetails)[i] === "avgpricepernight" ||
            Object.keys(summaryDetails)[i] === "incomepercapita") && formatValue !== '-'
            ? Config.Currency + formatValue
            : Object.keys(summaryDetails)[i] === "avgsizeofpark" && formatValue !== '-'
              ? formatValue + " Acres"
              : (Object.keys(summaryDetails)[i] === "percentageofhousehold" ||
                Object.keys(summaryDetails)[i] === "avgmaleInmarket" ||
                Object.keys(summaryDetails)[i] === "avgfemaleInmarket") && formatValue !== '-'
                ? formatValue + "%"
                : formatValue;
        summary.push(
          <tr key={Object.keys}>
            <td>{tableHeader}</td>
            <td>{headerValue}</td>
          </tr>
        );
      }
    }
    return summary;
  };


  const checkAvailableCount = () => {
    apiCommonTrigger("get", Config.API_URL + '/account/useravailability')
      .then((res) => {
        if (res.status === 200) {
          availCount = res.data.availablecount || 0;
          setAvailableCount(0);
        }
        else {
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })


  }

  //call API evey 3sec
  const startInterval = () => {
    intervalID = setInterval(() => checkAvailableCount(), 3000);
  }

  //stop the api calling interval
  const stopInterval = () => {
    clearInterval(intervalID);
  }



  return (
    <div
      className={
        activeStep === 2 || activeStep === 3
          ? "market-tabs-popup p-0 minise-market col"
          : activeStep === 4 ? "final-step add-market-wizard" : "add-market-wizard"
      }
    >
      {" "}
      {isLoading ? (
        <div className="loader-wrap">
          <div className="loading"></div>
        </div>
      ) : null}
      <div id="hit-avail-count" onClick={startInterval}></div>
      <div>
        <h5 className="wizard-title">{props.isEdit ? "Update" : "Add"} Market Wizard</h5>
        {activeStep === 0 ? (
          <div>
            <Container>
              <Col md="12">
                <div className="step completed">
                  <div className="v-stepper">
                    <div className="circle">1</div>
                    <div className="line"></div>
                  </div>
                  <div className="content">Market Name</div>
                </div>
                <div className="step completed">
                  <div className="v-stepper">
                    <div className="circle">2</div>
                    <div className="line"></div>
                  </div>
                  <div className="content">Define Radius</div>
                </div>
                <div className="step completed">
                  <div className="v-stepper">
                    <div className="circle">3</div>
                  </div>
                  <div className="content">Save</div>
                </div>
                <div className="wizard-btns">
                  <Button
                    onClick={() => props.showAddMarket(false, "2")}
                    color="secondary"
                    variant="contained"
                    className="close-btn"
                  >
                    Close
                  </Button>
                  <Button
                    onClick={() => {
                      nextStep(1);
                    }}
                    color="secondary"
                    variant="contained"
                    className="next-btn"
                  >
                    Next
                  </Button>
                  <div className="clear"></div>
                </div>
              </Col>
            </Container>
          </div>
        ) : activeStep === 1 ? (
          <div className="wizard-one">
            <Container>
              <Col md="12">
                <div className="step completed">
                  <div className="v-stepper">
                    <div className="circle">1</div>
                    <Label className="market-label"> Market Name </Label>
                  </div>
                </div>
                <TextField
                  id="outlined-basic"
                  label="Market Name"
                  variant="outlined"
                  name="marketName"
                  defaultValue={
                    marketInfo && marketInfo.marketName
                      ? marketInfo.marketName
                      : ""
                  }
                  onChange={handleChange}
                  className="textbox-custom"
                />
                <p className="error-msg" style={{ display: 'inline-block' }}>{errMsg && errMsg}</p>
                {(JSON.parse(localStorage.getItem('user')).usertype === 'Free' || JSON.parse(localStorage.getItem('user')).usertype === 'Basic') ?
                  <p className="text-right available-count">{availableCount ? availableCount + ' Available Market Report(s)' : ''}</p> : ''}
                <div className="clear"></div>
                <div className="wizard-btns">
                  <Button
                    onClick={() => nextStep(0)}
                    color="secondary"
                    variant="contained"
                    className="close-btn float-none"
                    disabled={props.isEdit}
                  >
                    Previous
                  </Button>
                  <Button
                    onClick={() => {
                      nextStep(2)
                    }}
                    className="next-btn float-right me-0"
                  >
                    Next
                  </Button>
                  {(JSON.parse(localStorage.getItem('user')).usertype === 'Free' || JSON.parse(localStorage.getItem('user')).usertype === 'Basic') && From !== 'my-market' && From == null && !availCount ?
                    (<Button
                      className="next-btn buy-market-btn"
                      onClick={() => navigateToBuyMarket()}
                    >
                      <AddShoppingCartIcon /> Buy Market at {localStorage.getItem('Currency') !== undefined && localStorage.getItem('Currency') !== null ? localStorage.getItem('Currency') : Config.Currency} {localStorage.getItem('Single_Market_Price') !== undefined && localStorage.getItem('Single_Market_Price') !== null ? localStorage.getItem('Single_Market_Price') : Config.Single_Market_Price}
                    </Button>) :
                    (<Button
                      onClick={() => submitRequest("1")}
                      id=""
                      className="save-close float-right"
                    >
                      Save and Close
                    </Button>)}

                  <div className="clear"></div>
                </div>
              </Col>
            </Container>{" "}
          </div>
        ) : activeStep === 2 ? (
          <div className="wizard-two">
            <Container>
              <Col md="12">
                <div className="step completed">
                  <div className="v-stepper">
                    <div className="circle">2</div>
                    <Label className="market-label"> Define radius </Label>
                  </div>
                </div>
                <p className="slider-info">
                  Use the slider bar to change the market distance
                </p>
                <p className="slider-info"> Click next to save</p>
                <div className="wizard-btns">
                  <Button
                    onClick={() => nextStep(1)}
                    id=""
                    className="close-btn"
                  >
                    Previous
                  </Button>
                  <Button onClick={() => getMarketSummary()} className="next-btn">
                    Next
                  </Button>
                  <div className="clear"></div>
                </div>
              </Col>
            </Container>
          </div>
        ) : activeStep === 3 ? (
          <div className="wizard-three">
            <Container>
              <Col md="12">
                <div className="step completed">
                  <div className="v-stepper">
                    <div className="circle">3</div>
                    <Label className="market-label"> Define Demand Area </Label>
                  </div>
                </div>
                <p className="slider-info">
                  Use the slider bar to change the Demand distance
                </p>
                <p className="slider-info">Click next to save</p>
                <div className="wizard-btns">
                  <Button
                    onClick={() => getMarketSummary()}
                    id=""
                    className="close-btn"
                  >
                    Previous
                  </Button>
                  <Button
                    onClick={() => getMarketSummary()}
                    id=""
                    className="next-btn"
                  >
                    Next
                  </Button>
                  <div className="clear"></div>
                </div>
              </Col>
            </Container>
          </div>
        ) : activeStep === 4 ? (
          <div className="wizard-four">
            <Container>
              <Col md="12">
                <div className="step completed">
                  <div className="v-stepper">
                    <div className="circle">3</div>
                    <Label className="market-label"> Confirm Market </Label>
                  </div>
                </div>
                <div className="summary-table-details">
                  <h5>Market Center </h5>
                  <p className="address-section">
                    {props.centerRadius} miles radius around {" "}
                    {profileData &&
                      profileData !== undefined &&
                      profileData.profile.streetaddress1
                      ? profileData.profile.streetaddress1 + ", "
                      : props.address
                        ? props.address
                        : ""}
                    {profileData &&
                      profileData !== undefined &&
                      profileData.profile.streetaddress2
                      ? profileData.profile.streetaddress2 + ", "
                      : ""}
                    {profileData &&
                      profileData !== undefined &&
                      profileData.profile.city
                      ? profileData.profile.city + ", "
                      : ""}
                    {profileData &&
                      profileData !== undefined &&
                      profileData.profile.statecode
                      ? profileData.profile.statecode + " "
                      : ""}
                    {profileData &&
                      profileData !== undefined &&
                      profileData.profile.zipcode
                      ? profileData.profile.zipcode
                      : ""}
                  </p>
                  <p style={{ fontSize: "11px" }} className="info-msg-us mb-1 add-market-confirmation">*Demographic data based on U.S. Census Bureau's 2023 American Community Survey.</p>

                  <div className="demand-area-section-common">
                  <Row>
                    <Col md={12} className={'free-user-tb'}>
                      <div className="table-summary-details">
                        <table className="market-center-table">
                          <tbody>
                            {marketResult && getSummaryDetails()}
                            {summary.length === 0 && !isLoading ? (
                              <tr>
                                <td
                                  style={{ textAlign: "center" }}
                                  className="store-no-data">
                                  No Data Available
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                      </div>
                    </Col>

                  </Row>
                  {(JSON.parse(localStorage.getItem('user')).usertype === 'Free' || JSON.parse(localStorage.getItem('user')).usertype === 'Basic') && From !== 'my-market' && From == null && availCount <= 0 ?
                              ""
                              :
                               marketResult.marketResult.marketdemandformarket !== null && marketResult.marketResult.marketdemandfornational !== null
                              || marketResult.marketResult.rvparkdemandscoreformarket !== null && marketResult.marketResult.rvparkdemandscorefornational !== null
                              || marketResult.marketResult.demandsupplyratioformarket !== null && marketResult.marketResult.marketdemandfornational !== null ? (
                                <Col md={5} className="ps-0 potential-camper-div"   >
                                <div className="draft-summary">
                                  { marketResult.marketResult.marketdemandformarket !== null && marketResult.marketResult.marketdemandfornational !== null ?
                                    <div className="score-details">
                                    <b>Potential Campers</b><br />
                                    <b>{ marketResult.marketResult.marketdemandformarket}%</b> of the market camps <br />
                                    <b>{ marketResult.marketResult.marketdemandfornational}%</b> of the nation camps
                                  </div> : ""}
                                  { marketResult.marketResult.rvparkdemandscoreformarket !== null && marketResult.marketResult.rvparkdemandscorefornational !== null ?
                                    <div className="score-details mt-1">
                                    <Tooltip title="Camping Demand based on Proximity, Income, Ethnicity, and Age" placement="top" arrow>
                                      <b>Potential Campers based on Demand<InfoOutlined className="info-tooltip"/></b>
                                    </Tooltip><br />
                                    <b>{priceConversion(marketResult.marketResult.rvparkdemandscoreformarket)}</b> market potential campers<br />
                                    <b>{priceConversion(marketResult.marketResult.rvparkdemandscorefornational)}</b> national average of potential campers
                                  </div> : ""}
                                  { marketResult.marketResult.demandsupplyratioformarket !== null  && marketResult.marketResult.marketdemandfornational !== null ?
                                    <div className="score-details mt-1">
                                    <Tooltip title="Number of Campers per Camping Spots." placement="top" arrow>
                                      <b>Campers per Camping Spots<InfoOutlined className="info-tooltip"/></b>
                                    </Tooltip><br />
                                    <b>{marketResult.marketResult.demandsupplyratioformarket}</b> market ratio <br />
                                    <b>{marketResult.marketResult.demandsupplyratiofornational}</b> national ratio
                                  </div> : ""}   
                                </div>
                            </Col> 
                              )  : ""  
                            
                              
                  }

                  </div>
                </div>
                <div className="wizard-btns">
                  <Button
                    onClick={() => nextStep(2)}
                    id=""
                    className="close-btn"
                  >
                    Previous
                  </Button>

                  {
                    (JSON.parse(localStorage.getItem('user')).usertype === 'Free' || JSON.parse(localStorage.getItem('user')).usertype === 'Basic') && From !== 'my-market' && From == null && !availCount ?
                      (<Button
                        className="next-btn buy-market-btn"
                        onClick={() => navigateToBuyMarket()}

                      >
                        <AddShoppingCartIcon /> Buy Market at {localStorage.getItem('Currency') !== undefined && localStorage.getItem('Currency') !== null ? localStorage.getItem('Currency') : Config.Currency} {localStorage.getItem('Single_Market_Price') !== undefined && localStorage.getItem('Single_Market_Price') !== null ? localStorage.getItem('Single_Market_Price') : Config.Single_Market_Price}
                      </Button>) : (
                        <Button
                          className="next-btn"
                          onClick={() => submitRequest("2")}
                        >
                          Save
                        </Button>
                      )
                  }
                  {/* <Button
                    className="next-btn"
                    onClick={() => submitRequest("2")}
                  >
                    Save
                  </Button> */}
                  {(JSON.parse(localStorage.getItem('user')).usertype === 'Free' || JSON.parse(localStorage.getItem('user')).usertype === 'Basic') ?
                    <p className="float-right available-count me-2 pe-1">{availableCount ? availableCount + ' Available Market Report(s)' : ''}</p> : ''}

                  <div className="clear"></div>
                </div>
              </Col>
            </Container>
          </div>
        ) : activeStep === 5 ? (
          <div className="success-market-msg">
            <h3>Market Added Successfully!</h3>
            <div>
              <p>
                <div className="popup-success-btn">
                  <Button onClick={() => clearAll("2")} className="close-info">
                    Close
                  </Button>
                  <Link
                    className="view-market"
                    to={"/market-dashboard/interactive-map/" + marketId}
                    onClick = {dispatch({ type: 'developmentFilters', value: [] })}
                  //onClick={() => openDashboard(true)}
                  >
                    View This Market
                  </Link>
                  <Link
                    className="go-my-market"
                    to="/my-market"
                  >
                    Go to Markets List
                  </Link>
                </div>
              </p>
            </div>
          </div>
        ) : ""}
      </div>
    </div>
  );
});

export default AddMarket;
